import { memo } from "react";
import type { SetupValueFunctionComponent } from "./types";
import { String } from "./String";
import { FormField } from "../types";
import SetupValueRegistry from "./registry";

const SetupValue: SetupValueFunctionComponent = ({
    registry = SetupValueRegistry,
    ...restProps
}) => {
    const {
        initialValues,
        values,
        setFieldValue,
        setFieldTouched
    } = restProps;

    const [SetupValueComponent = String] = SetupValueRegistry.get(initialValues.valueType) || [];

    const onChange = <T extends unknown>(value: T) => {
        setTimeout(() => setFieldTouched(FormField.SetupValue, true));
        setFieldValue(
            FormField.SetupValue,
            values[FormField.SetupValue].update(value),
            true
        );
    };

    return (
        <SetupValueComponent
            {...restProps}
            onChange={onChange}
        />
    );
};

export default memo(SetupValue);
